import { render, staticRenderFns } from "./FieldProperties.vue?vue&type=template&id=0f694a0e&scoped=true"
import script from "./FieldProperties.vue?vue&type=script&lang=js"
export * from "./FieldProperties.vue?vue&type=script&lang=js"
import style0 from "./FieldProperties.vue?vue&type=style&index=0&id=0f694a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f694a0e",
  null
  
)

export default component.exports